/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_TitleInputs */

const cs_integrations_title = /** @type {(inputs: Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrace`)
};

const en_integrations_title = /** @type {(inputs: Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrations`)
};

/**
* | output |
* | --- |
* | "Integrations" |
*
* @param {Integrations_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_title = /** @type {((inputs?: Integrations_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_title(inputs)
	return cs_integrations_title(inputs)
});